import React, { useEffect } from 'react';
import { InkyPenNavbar } from './InkyPenNavbar/InkyPenNavbar';
import { useAtom, useAtomValue } from 'jotai';
import { useHistory, useParams } from 'react-router-dom';
import { ArticleAtomFamily, ArticleFetchState, FetchNewsAtom } from '../store/NewsArticleStore';
import { TextCensor } from '../Components/Censor';
import './InkyPenArticle.scss';
import { convertDate } from '../utils/utils';
import EmailVerifiedPage from './Articles/EmailVerifiedPage';
import InkyPenSubscription from './InkyPenSubscription/InkyPenSubscription';
import { InkyPenFooter } from './InkyPenFooter/InkyPenFooter';
import { InkyPenNotFound } from './InkyPenNotFound/InkyPenNotFound';
import { serialize } from '@wordpress/blocks';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import Log from './Services/Logger';

const checkParamsIfUndefined = (year, month, day, aid): boolean => {
    return [year, month, day, aid].some(param => param === undefined);
};

export interface InkypenArticleParams {
    year?: string;
    month?: string;
    day?: string;
    aid: string;
}

interface InkypenArticleProps {
    overrideUrl?: string;
}

export function InkyPenArticle(props: InkypenArticleProps): JSX.Element {
    const { year, month, day, aid } = useParams<InkypenArticleParams>();
    const history = useHistory();
    const queryParameters = new URLSearchParams(window.location.search)
    Log.info("OverrideUrl" + props.overrideUrl);
    console.log(queryParameters);

    if (history.location.pathname === '/email-verified') {
        EmailVerifiedPage();
    }

    // This is unsafe, we should seek another solution to get the type of the page in custom pages from server
    if (!checkParamsIfUndefined(year, month, day, aid)) {

    }

    function getUrl() {
        if(props.overrideUrl) {
            return props.overrideUrl;
        }
        if (year && month && day) {
            return `${year}/${month}/${day}/${aid}`;

        }

        return aid;
    }

    const url = getUrl();


    const [articleFetchStatus, fetchArticle] = useAtom(FetchNewsAtom(url));

    useEffect(() => {
        // Fetch the article on mount only.
        //TODO: FIGURE OUT WHY AN ARGUMENT IS NEEDED HERE,
        // I have no clue my compiler needs it, but webstorm gives no indication
        fetchArticle();
    }, []);


    if (articleFetchStatus === ArticleFetchState.Fetched) {
        return (
            <div className={'inkypen-article-container'}>
                <FoundArticle url={url} year={year}/>
                {/*<InkyPenSubscription />*/}
                <InkyPenFooter />
            </div>
        );
    }

    // ... or return a 404 if there is no article returned.
    if (articleFetchStatus === ArticleFetchState.Error) {
        return (<InkyPenNotFound />);
    }


    return <InkyPenNavbar />;
}

interface FoundArticleProps {
    url: string;
    year?: string;
}

function FoundArticle(props: FoundArticleProps): JSX.Element {
    const articleWrapper = useAtomValue(ArticleAtomFamily(props.url));

    const article = articleWrapper?.article;
    if(!article) {
        return null;
    }

    const src = article.thumbnails[0]?.url;
    const alt = article.title;

    const publishDate = convertDate(article.publishDate);
    if (article) {
        ReactGA.send({ hitType: 'pageview', page: window.location.href, title: 'News | ' + article.title });
    }

    Log.debug("Article content:",article);

    return (
        <React.Fragment>
            <Helmet>
                <title>{article?.title ?? "InkyPen | Discover Manga & Comics"}</title>
            </Helmet>
            <div className={'inkypen-article'}>
                <InkyPenNavbar />
                <div className='article-container'>
                    <h1><TextCensor text={article.title} /></h1>
                    <div className={'ui-article-poster'}>
                        {props.year && <div className={'ui-article-poster-date'}>{publishDate}</div>}
                        <img src={src} alt={alt} className={'ui-article-poster-image'}
                             style={{ width: src === '' && 'auto' }} />
                    </div>
                    <div className={'content'} dangerouslySetInnerHTML={{
                        __html: ((): string => {
                            try {
                                return serialize(JSON.parse(article.content));
                            } catch (e) {
                                console.log('The data is already string');
                                return article.content;
                            }
                        })(),
                    }}></div>
                </div>
            </div>
        </React.Fragment>
    );
}
